export default "__VITE_ASSET__4a62aaa2__"